import React from 'react';
import PropTypes from 'prop-types';

import {
    Label, Radio,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import { StyledFlexContainer } from './StyledComponents';

const propTypes = {
    label: PropTypes.node.isRequired,
    description: PropTypes.node,
    helperText: PropTypes.node,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
const defaultProps = {
    description: null,
    helperText: null,
};

const RadioButton = ({
    label, description, helperText, checked, name, id, onClick,
}) => (
    <>
        <StyledFlexContainer
            display="flex"
            justifyContent="center"
            flexDirection="column"
            paddingY="md"
            paddingX="sm"
            onClick={onClick}
            for={id}
            active={checked}
            marginBottom="xs"
        >
            <Row noMargin={true}>
                <Col
                    xs={2}
                    alignVertical="center"
                    alignHorizontal="center"
                    noPadding={true}
                >
                    <Radio name={name} id={id} checked={checked} />
                </Col>
                <Col xs={description ? 5 : 10} alignVertical="center" alignHorizontal="center" noPadding={true}>
                    <Label size="lg">{label}</Label>
                </Col>
                {description && (
                    <Col
                        xs={5}
                        alignVertical="center"
                        alignHorizontal="center"
                        noPadding={true}
                    >
                        {description}
                    </Col>
                )}
            </Row>
        </StyledFlexContainer>
        {helperText}
    </>
);

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default RadioButton;
